import { useQuery } from "@tanstack/react-query";
import { getPidDetail, getPlantTree } from "../api/pidExplorer";

export function usePlantTree(plantId: string | null) {
  return useQuery({
    queryKey: ["pid-explorer", "tree", plantId],
    queryFn: () => getPlantTree(plantId!),
    enabled: !!plantId,
  });
}

export function usePidDetail(plantId: string | null, pidId: string | null) {
  return useQuery({
    queryKey: ["pid-explorer", "pid", plantId, pidId],
    queryFn: () => getPidDetail(plantId!, pidId!),
    enabled: !!plantId && !!pidId,
  });
}
